import PolicyService from "../PolicyService/PolicyService.ts";

// Document types and status of wing-backend's empty-documents report (getEmptyDocs).
const STICKERS = "2";
const GREEN_CARDS = "4";
const FREE = "0";

/**
 * The free numbers of one blank type that Wing holds for an insurer agency
 * (INS_COMP.CID) and agent (AGENTS.AID), as the "Празни документи" report lists
 * them. wing-backend still limits them to the agents the user's offices may see.
 */
const freeNumbers = async (
  jwt: string,
  documentType: string,
  cid: string,
  agentId: string
): Promise<string[]> => {
  const rows = await PolicyService.fetchEmptyDocuments(
    {
      documentType,
      documentStatus: FREE,
      insuranceCompany: cid,
      agent: agentId,
      office: "all",
      insuranceType: "all",
    },
    jwt
  );
  return Array.isArray(rows)
    ? rows
        .map((row) => String((row as { Number?: unknown })?.Number ?? "").trim())
        .filter(Boolean)
    : [];
};

export const BlankService = {
  fetchFreeStickers: (jwt: string, cid: string, agentId: string) =>
    freeNumbers(jwt, STICKERS, cid, agentId),
  fetchFreeGreenCards: (jwt: string, cid: string, agentId: string) =>
    freeNumbers(jwt, GREEN_CARDS, cid, agentId),
};
